define('settings/lib/reservation/reservation',['require','durandal/app','knockout','web-urls','gotomeet/setup/setup-modal','meeting-modal/gotomeet/personalize-meeting','meeting-modal/organizerPIN/edit-organizer-pin','api-access','mixpanel-helper','api-access'],function (require) {
    var app = require('durandal/app');
    var ko = require('knockout');
    var webUrls = require('web-urls');
    var SetupModal = require('gotomeet/setup/setup-modal');
    var personalizeMeeting = require('meeting-modal/gotomeet/personalize-meeting');
    var editOrganizerPIN = require('meeting-modal/organizerPIN/edit-organizer-pin');
    var g2mmApi = require('api-access').gotomeet;
    var mixpanelHelper = require('mixpanel-helper');
    var userApi = require('api-access').user;

    return function () {
        var self = this;

        self.gotoMeetMeUrl = webUrls.get('gotoMeetMeUrl');
        self.g2mmProfile = ko.observable();
        self.isG2mmRetrieved = ko.observable(false);
        self.organizerPIN = ko.observable();
        self.isOrganizerPinEnabled = ko.observable(false);
        self.isOpenPresenterModeSelected = ko.observable(false);

        self.isOrganizerPinSet = ko.computed(function () {
            return self.organizerPIN() && (self.organizerPIN() !== '');
        });

        self.personalizeMeeting = function () {
            mixpanelHelper.track('Open Personalize Meeting');
            personalizeMeeting.show();
        };

        self.editOrganizerPIN = function () {
            editOrganizerPIN.show(self.organizerPIN(), function (organizerPIN) {
                self.organizerPIN(organizerPIN);
            });
        };

        self.showSetupModal = function () {
            SetupModal.show();
        };

        self.wilcardedOrganizerPIN = function () {
            if (!self.isOrganizerPinSet()) return '';

            var pin = self.organizerPIN();
            return pin.charAt(0) + ('*'.repeat(pin.length - 2)) + pin.charAt(pin.length - 1);
        };

        self.activate = function () {
            g2mmApi.getByUserKey()
                .then(function (g2mmProfile) {
                    self.g2mmProfile(g2mmProfile);
                })
                .always(function () {
                    self.isG2mmRetrieved(true);
                });

            userApi.settings().then(function (settings) {
                self.organizerPIN(settings.conferenceModeratorPin);
                self.isOrganizerPinEnabled(settings.isStandaloneAudioProvisioned && settings.isStandaloneAudioEntitled && settings.isStandaloneAudioEnabled);
                self.isOpenPresenterModeSelected(settings.presenterMode && (settings.presenterMode === 'open'));
            });
        };

        app.on('gotomeet:updatedProfileId').then(function (profileId) {
            var g2mmProfile = self.g2mmProfile();
            g2mmProfile.profileId = profileId;

            self.g2mmProfile(g2mmProfile);
        });

        app.on('get:settings', function () {
            self.activate();
        });
    };
});

